import React, { Component, Fragment } from 'react';
import robot from '../assets/404/robot-brak-listy.svg';
import logo from '../assets/404/logo.svg';

class NotFound extends Component {
	render() {
		return (
			<Fragment>
				<div className="landing-notFound-container">
					<div className="landing-popup">
						<img src={logo} alt="404-logo" />
						<div className="landing-popup-content">
							<div className="landing-popup-content-msg">
								<h1>Error 404</h1>
								<h2>Connection problem</h2>
								<h2>Try again</h2>
							</div>
							<img src={robot} alt="404-robot" />
						</div>
					</div>
				</div>
			</Fragment>
		);
	}
}

export default NotFound;
